<template>
  <div class="column">
    <Skeletor width="100%" height="60" />
  </div>
</template>
